/** Per-user Particle Editor UI state (open modules, preview visibility) in localStorage. */

const KEY = 'ai-studio:particle-editor';

interface Prefs {
  /** Module keys whose cards are collapsed. */
  collapsed: string[];
  showPreview: boolean;
}

const DEFAULTS: Prefs = { collapsed: ['velocityOverLifetime', 'limitVelocityOverLifetime', 'forceOverLifetime', 'noise', 'collision', 'subEmitters', 'textureSheetAnimation'], showPreview: true };

export function loadPrefs(): Prefs {
  try {
    const raw = typeof localStorage === 'undefined' ? null : localStorage.getItem(KEY);
    const v = raw ? (JSON.parse(raw) as Partial<Prefs>) : {};
    return {
      collapsed: Array.isArray(v.collapsed) ? v.collapsed.filter((k): k is string => typeof k === 'string') : DEFAULTS.collapsed,
      showPreview: typeof v.showPreview === 'boolean' ? v.showPreview : DEFAULTS.showPreview,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function savePrefs(prefs: Prefs): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // Storage blocked: the panel still works for this session.
  }
}
